import { ChangeDetectionStrategy, Component, isDevMode } from '@angular/core';

/**
 * Component with app header element
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderComponent {
  protected readonly aiChatEnabled = isDevMode();
}
